import { render, staticRenderFns } from "./CoriolisEffectViz.vue?vue&type=template&id=6b6cd688&scoped=true"
import script from "./CoriolisEffectViz.vue?vue&type=script&lang=js"
export * from "./CoriolisEffectViz.vue?vue&type=script&lang=js"
import style0 from "./CoriolisEffectViz.vue?vue&type=style&index=0&id=6b6cd688&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6cd688",
  null
  
)

export default component.exports